const STORAGE_NAME_RE =
  /(?:^|[^a-z])(?:closet|storage|laundry|pantry|utility|mudroom|mud room|wic)(?:[^a-z]|$)/i;

/**
 * Closets / storage / laundry / pantry-type rooms should never get label covers.
 * @param {Object|null|undefined} room
 * @returns {boolean}
 */
export function isStorageLikeRoom(room) {
  if (!room || typeof room !== "object") return false;

  const roomType = room.room_type;
  const typeList = Array.isArray(roomType)
    ? roomType.map((t) => String(t).toLowerCase())
    : typeof roomType === "string"
      ? [roomType.toLowerCase()]
      : [];

  if (typeList.includes("storagemedia")) return true;

  const name = String(room.room_name || room.name || "").trim();
  if (!name) return false;

  // Bathroom "water closet" / WC is not storage — don't let /closet/ false-positive.
  if (/\bwater\s*closet\b/i.test(name) || /(^|[^a-z])wc([^a-z]|$)/i.test(name)) {
    return false;
  }

  return STORAGE_NAME_RE.test(name);
}

/**
 * @param {Object|null|undefined} roomsDataEntry
 * @param {number|string|null|undefined} activeLayoutIndex
 * @returns {boolean}
 */
export function roomHasActiveFurniture(roomsDataEntry, activeLayoutIndex) {
  const furniture =
    roomsDataEntry?.layouts?.[activeLayoutIndex]?.furniture;
  return Array.isArray(furniture) && furniture.length > 0;
}

/**
 * Cover plan labels when the Plan labels toggle is off, the room has furniture
 * in the active layout, and the room is not storage-like.
 * Independent of the Furniture visibility toggle — hiding furniture must not
 * disable Plan labels.
 *
 * @param {{
 *   room: Object|null|undefined,
 *   roomsDataEntry: Object|null|undefined,
 *   activeLayoutIndex: number|string|null|undefined,
 *   planLabelsVisible: boolean,
 * }} args
 * @returns {boolean}
 */
export function shouldCoverPlanLabelsForRoom({
  room,
  roomsDataEntry,
  activeLayoutIndex,
  planLabelsVisible,
}) {
  if (planLabelsVisible) return false;
  if (isStorageLikeRoom(room)) return false;
  return roomHasActiveFurniture(roomsDataEntry, activeLayoutIndex);
}

/**
 * @param {Object|null|undefined} box
 * @returns {string}
 */
export function getCoverFill(box) {
  const raw = box?.bg_hex;
  if (typeof raw === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw.trim())) {
    return raw.trim();
  }
  return "#FFFFFF";
}
